import React from 'react';
import styled from 'styled-components';

interface ProportionBarItem {
  id: string;
  value: number;
  color: string;
}

export interface ProportionBarProp {
  items: ProportionBarItem[];
  maximumValue: number;
  hideValues?: boolean;
}

interface StyledBarItemProp {
  value: number;
  totalValue: number;
  bgColor: string;
}

const ProportionBarContainer = styled.div`
  display: flex;
`;

const ProportionBarItemContainer = styled.div`
  background-color: var(--benefit-usage-divider-color);
  width: 100%;
  display: flex;
`;

const StyledBarItem = styled.div<StyledBarItemProp>`
  width: ${({ value, totalValue }) => `${(value / totalValue) * 100}%`};
  background-color: ${({ bgColor }) => bgColor};
  color: #fff;
  text-align: center;
`;

const ValueLabel = styled.div`
  margin-left: 8px;
`;

const formatTotalValue = (value: number) => {
  return value % 1 !== 0 ? value.toFixed(2) : value;
};

function ProportionBar({ items, maximumValue, hideValues }: ProportionBarProp) {
  const totalValue = formatTotalValue(items.reduce((sum, item) => sum + item.value, 0));
  return (
    <ProportionBarContainer>
      <ProportionBarItemContainer>
        {items.map((item) => (
          <StyledBarItem
            key={item.id}
            value={item.value}
            totalValue={maximumValue}
            bgColor={item.color}
            data-testid="mock-barItem"
          >
            {item.value && !hideValues ? item.value : ''}
          </StyledBarItem>
        ))}
      </ProportionBarItemContainer>
      <ValueLabel data-testid="mock-valueLabel">{`${totalValue}/${maximumValue}`}</ValueLabel>
    </ProportionBarContainer>
  );
}

export default ProportionBar;
